import React, { ReactElement, useContext, useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import { useDispatch, useSelector } from "react-redux";
import { ISchemaNode, ISelectedNode, IState } from "../types";
import { selectedNode, toggleLeftPanel } from "../actions";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Box, Collapse, ListItemButton } from "@mui/material";
import { SystemContext } from "../context/systemContext";

interface ITreeNodeProps  {
  node: ISchemaNode;
  selected: ISelectedNode | null;
  level: number;
}

const styles = {
  nested0: {
    pl: "1em"
  },
  nested1: {
    pl: "2em"
  },
  nested2: {
    pl: "3em"
  },
  nested3: {
    pl: "4em"
  }
};

const TreeNode = ({ node, level, selected }: ITreeNodeProps): ReactElement => {
  const dispatch = useDispatch<any>();
  const [open, setOpen] = useState(level < 2 && !node.inactivated);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (!node.inactivated) {

      dispatch(selectedNode({
        nodeID: node.nodeID,
        code: node.code,
        name: node.name,
        color: node.color,
        timezone: node.timezone,
        type: node.type,
        menu: node.menu,
        indicator: node.indicator,
        children: node.children
      }));
    }
  };

  const hasChildren = level < 2 && node.children && node.children.length > 0;

  // className={`${selected?.nodeID === node.nodeID && selected.type === node.type ? "selected-item" : ""} ${node.inactivated ? "disabled-item" : ""}`}

  return(
    <>
      <ListItemButton
        disabled={node.inactivated }
        sx={styles[`nested${level}` as keyof typeof styles]}
        onClick={handleClick}
        selected={selected?.nodeID === node.nodeID && selected.type === node.type}>
        <ListItemText primary={node.name} />
        { hasChildren && open && <ExpandLess onClick={() => setOpen(!open)} />}
        { hasChildren && !open &&  <ExpandMore onClick={() => setOpen(!open)} />}
      </ListItemButton>
      { level < 2 && node.children &&
        <Collapse in={open} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            { node.children.map((n, i) =>
              <TreeNode key={`node-org-${level}-${i}`} node={n} level={level + 1} selected={selected}/>
            )
            }
          </List>
        </Collapse>
      }
    </>
  );
};


const LeftPanel = (): ReactElement => {
  const systemContext = useContext(SystemContext);
  const dispatch = useDispatch<any>();
  const open = useSelector((state: IState) => state.panels.left);
  const selected = useSelector((state: IState) => state.selectedNode);
  const organization = systemContext.schema;

  return(
    <Drawer open={open && organization.length > 0} anchor="left" onClose={() => dispatch(toggleLeftPanel())} >
      <Box
        role="presentation"
        onClick={() => dispatch(toggleLeftPanel())}
        onKeyDown={() => dispatch(toggleLeftPanel())} >
        <List>
          { organization.map((node, index) => {
            return(
              <TreeNode key={`schema-node-${index}`} node={node} level={0} selected={selected}/>
            );
          })

          }
        </List>
      </Box>
    </Drawer>
  );
};

export default LeftPanel;
